import React from 'react';
import PropTypes from 'prop-types';

const EmployeeStatistic = ({ header, data, style }) => (
  <div style={style} className="statistic">
    <div className="statisticHeader">{header}</div>
    <div className="statisticData">{data}</div>
  </div>
);

EmployeeStatistic.propTypes = {
  header: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  style: PropTypes.object,
};

EmployeeStatistic.defaultProps = {
  style: {},
  data: '',
};

export default EmployeeStatistic;
